import { InferGetStaticPropsType } from 'next'

import { VenueMeta } from '@modules/venue/views/venue-meta'

import { ssgPaths, ssgProps } from '@utils/server'
import { VenueHomeView } from '@modules/venue/views/venue-home-view'
import { serveVenueHomePageProps } from '@modules/venue/data/server'
import { VenuePageProvider } from '@modules/venue/controllers/venue-page-provider'
import * as env from '@lib/env'

export default function VenueHomePage({
  venue,
  integrations,
  events,
  tickets,
  packages,
  layouts,
  sections,
  tables
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <>
      <VenueMeta venue={venue} />
      <VenuePageProvider venue={venue} integrations={integrations} largePageBanner>
        <VenueHomeView
          venue={venue}
          events={events.data}
          tickets={tickets.data}
          packages={packages.data}
          layouts={layouts}
          sections={sections}
          tables={tables}
        />
      </VenuePageProvider>
    </>
  )
}

export const getStaticProps = ssgProps(serveVenueHomePageProps)

export const getStaticPaths = ssgPaths(env.isProd ? ['/v/clubtablelist'] : [])
